import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import theme from "styles/theme";
import List from "components/icons/active-list";
import FlatButton from "material-ui/FlatButton";
import { merge, $ } from "glamor";
import classNames from "classnames";
import Globalize from "globalize";
import Button from "components/form/button";

const styles = {
    listIconInactive: {
        opacity: 0.3,
    },
    button: {
        width: "100%",
        marginTop: "12px",
    },
    listButton: {
        display: "block",
        minWidth: "44px",
        margin: "10px 0 0 0",
    },
    buttonLabel: {
        color: theme.palette.primary1Color,
        paddingRight: "12px",
        paddingLeft: "12px",
    },
    icon: {
        fill: theme.palette.darkGrey,
        width: "20px",
        height: "20px",
    },
    iconWithEntries: {
        marginLeft: "12px",
    },
};

const dropdownStyles = merge(
    {
        position: "absolute",
        display: "block",
        top: "100%",
        right: 0,
        width: "272px",
        maxWidth: "272px",
        background: "white",
        maxHeight: "0px",
        opacity: 0,
        zIndex: 12,
        transition: "all .3s ease-in",
        overflowY: "auto",
        padding: "0 24px",
        boxShadow: "0px 4px 12px rgba(0,0,0,.4)",
    },
    $(".open", {
        maxHeight: "326px",
        padding: "12px 24px 20px",
        opacity: 1,
    }),
    $(" .title", {
        fontSize: "24px",
        padding: "8px 0",
        margin: "0px",
        color: theme.palette.darkestGrey,
    }),
);

const Dropdown = ({ show, activeList, onSelectList }) => {
    return (
        <div {...dropdownStyles} className={classNames({ open: show })}>
            <h3 style={styles.title}>{activeList.current.title}</h3>
            <div>
                <Button
                    label={Globalize.formatMessage("Switch Active List")}
                    style={styles.button}
                    onClick={onSelectList}
                />
                <Button
                    href={activeList.current._link}
                    primary={true}
                    label={Globalize.formatMessage("Go to Active List")}
                    style={styles.button}
                />
            </div>
        </div>
    );
};

class ActiveList extends PureComponent {
    static propTypes = {
        activeList: PropTypes.object.isRequired,
        onSelectList: PropTypes.func.isRequired,
        touchDevice: PropTypes.bool,
    };

    styles = merge({
        position: "relative",
    });

    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };

        this.handleItemEnter = this.handleItemEnter.bind(this);
        this.handleItemLeave = this.handleItemLeave.bind(this);
        this.handleToggleOpen = this.handleToggleOpen.bind(this);
    }

    UNSAFE_componentWillMount() {
        if (this.props.touchDevice) {
            window.addEventListener("click", this.handleItemLeave);
        }
    }

    componentWillUnmount() {
        if (this.props.touchDevice) {
            window.removeEventListener("click", this.handleItemLeave);
        }
    }

    handleItemEnter() {
        this.setState({ open: true });
    }

    handleItemLeave() {
        this.setState({ open: false });
    }

    handleToggleOpen(e) {
        e.stopPropagation();
        this.setState({ open: !this.state.open });
    }

    render() {
        const { activeList, onSelectList, touchDevice } = this.props;
        const { open } = this.state;

        // prettier-ignore
        const listButtonProps = activeList.current
            ? {
                href: touchDevice ? undefined : activeList.current._link,
                onClick: touchDevice ? this.handleToggleOpen : undefined,
            } : { onClick: onSelectList };

        return (
            <div
                {...this.styles}
                onMouseEnter={touchDevice ? undefined : this.handleItemEnter}
                onMouseLeave={touchDevice ? undefined : this.handleItemLeave}
            >
                <FlatButton
                    label={activeList.current ? activeList.entries.size : undefined}
                    style={Object.assign({}, styles.listButton, !activeList.current && styles.listIconInactive)}
                    labelStyle={styles.buttonLabel}
                    icon={<List style={Object.assign({}, styles.icon, activeList.current && styles.iconWithEntries)} />}
                    {...listButtonProps}
                />
                {activeList.current && <Dropdown show={open} activeList={activeList} onSelectList={onSelectList} />}
            </div>
        );
    }
}

export default ActiveList;
